import React, { useRef } from "react";
import TSTable from "../common/TSTable";
import { Tooltip, DatePicker, Form, Popover, Row, Col, Select, Input, theme, Button } from "antd";
import { URL_POND, URL_REPORT, URL_TRUCK } from "../constants/urls";
import * as _ from "lodash";
import {
  dateToHumanString,
  formatComma,
  getLabResultColor,
  timeToString,
  toFixed,
} from "../frameworks/Util";
import {
  CheckOutlined,
  HistoryOutlined
} from '@ant-design/icons';
import ErrorMessages from "../common/ErrorMessages";
import ReceivingWeightLogModal from "../components/receiving-latex/ReceivingWeightLogModal";
import SummaryWeightLatex from "../components/common/SummaryWeightLatex"
import { PATH } from "../routes/CustomRoutes";
import { POST } from "../frameworks/HttpClient";
import ColorButton from "../common/ColorButton";
import useDropdownItem from "../common/useDropdownItem";
import ReportButton from "../components/common/ReportButton";
import dayjs from "dayjs";

const PondRecieveLatexView = React.forwardRef((props, ref) => {
  const [targetOutWeightLog, setTargetOutWeightLog] = React.useState(null);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [targetInWeightLog, setTargetInWeightLog] = React.useState(null);
  const [form] = Form.useForm();
  const [rangeDate , setRangeDate] = React.useState({date_after : dayjs().format('YYYY-MM-DD'), date_before : dayjs().format('YYYY-MM-DD')});
  const tableRef = useRef(null);
  const popoverRef = useRef(null);
  const pondDropdown = useDropdownItem({ url: URL_POND.POND, 
    label_renderer: (option) => `${option.name} [${ option.lot_no }]`,
    value:'current_transaction', 
    pagination: true, 
    params: { state: "filling" } 
  })

  const {
    token: { colorSuccess, colorPrimary },
  } = theme.useToken();

  const handleFillLatex = async(truck_id) => {
    setErrorMessages(null);
    try {
      const data = await form.validateFields();
      data["truck_transaction"] = truck_id
      await POST(URL_POND.POND_TRUCK_TRANSCATION, data)
      await refreshData();
      popoverRef.current?.popover?.setVisible(true);
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  }

  const refreshData = async (params = {}) => {
    if (tableRef.current) await tableRef.current.fetch(params);
  };

  const columns = [
    {
      title: "Action",
      dataIndex: "id",
      key: "id",
      render : (value, original) => 
        <div 
            style={{textAlign:'center'}}
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            <Tooltip triger='hover' title={"ประวัติรถ"}>
            <ColorButton
              type='primary'
              override={colorPrimary}
              style={{ margin : 5}}
              icon={<HistoryOutlined />}
              onClick={()=> window.open(`${window.origin}${PATH.POND_TRUCK_HISTORY}/${value}`)} 
            /></Tooltip>
          {original.is_approved && !original.pond_input && <Popover
            ref = {popoverRef}
            content={(
            <Form form={form} style={{ height : 120 }}>
              <Row>
                <Col>
                  <Form.Item
                    name={'pond_transaction'}
                    layout={'vertical'}                                                                                                                               
                    label={'เลือกบ่อ'}
                    style={{ height : 60}}
                    rules={[{ required : true, message: 'กรุณากรอกข้อมูล' }]}
                  >
                    <Select options={pondDropdown.options} style={{ width : 200, marginRight : 10}} placeholder={'บ่อ'}/>
                  </Form.Item>
                </Col>

                <Col>
                  <Form.Item
                    name={'tray'}
                    layout={'vertical'}                                                                                                                               
                    label={'กระบะ'}
                    style={{ height : 60}}
                  >
                    <Input style={{ width : 150}} placeholder={'กระบะ'}/>
                  </Form.Item>
                </Col>
              </Row>


              <ColorButton 
                type='primary'
                override={colorSuccess}
                onClick={()=> handleFillLatex(value)} 
                style={{ float : 'right',  marginLeft : 10, margin : 5}}
              >
                ตกลง
              </ColorButton>

              {/* <ColorButton 
                override={colorSuccess}
                onClick={handleClose}
                style={{ float : 'right'}}
              >
                ยกเลิก
              </ColorButton> */}
            </Form>
            )}
            placement='top'
            trigger='click'
            onOpenChange={()=> {
              form.resetFields();
            }}>
              <Tooltip triger='hover' title={"เทน้ำยางลงบ่อ"}>
              <ColorButton 
                type='primary'
                override={colorSuccess}
                icon={<CheckOutlined />}
              /></Tooltip>
            </Popover>}
            { (_.get(original, "is_approved", null) === true || _.get(original, "is_approved", null) === null) &&
              <ReportButton
                url={`${URL_REPORT.LAB_REQUEST_ORDER}${original.lab_order}/`} 
                tooltip={'พิมพ์ฉลากน้ำยางสด'}
                sentError={(e) => setErrorMessages(e)}
              />
            }
          </div>
    },
    {
      title: "ลำดับ",
      dataIndex: "index",
      key: "index",
    },
    {
      title: "เที่ยวที่",
      dataIndex: "round_trip",
      key: "round_trip",
    },
    {
      title: "เลขที่บัตร",
      dataIndex: "code",
      key: "code",
      searcher: true,
    },
    {
      title: "รหัสผู้ขาย",
      dataIndex: "supplier_code",
      key: "supplier_code",
      searcher: true,
    },
    {
      title: "ทะเบียนรถ",
      dataIndex: "vehicle_license_plate",
      key: "vehicle_license_plate",
      searcher: true,
      render : (value, original) => 
      <Tooltip triger='hover' title={"ประวัติรถเข้าโรงงาน"}>
        <a onClick={()=> window.open(`${window.origin}${PATH.POND_TRUCK_HISTORY}/${original.id}`)}>
          {value}
        </a>
      </Tooltip>
    },
    {
      title: "เข้า",
      children: [
        {
          title: "วัน - เวลา",
          dataIndex: "in_datetime",
          key: "in_datetime",
          render: (value) => {
            return (
              <center>
                <div>{value ? dateToHumanString(value) : "-"}</div>
                <div>{value ? timeToString(value) : ""}</div>
              </center>
            );
          },
        },
        {
          title: "น้ำหนัก",
          dataIndex: "in_weight",
          key: "in_weight",
          render: (value, original) => (
            <>
              <Tooltip triger='hover' title={"ประวัติน้ำหนักเข้า"}>
                <a onClick={() => setTargetInWeightLog({ id: original.id })}>
                  {formatComma(toFixed(value, 0))}
                </a>
              </Tooltip>
            </>
          ),
        },
      ],
    },
    {
      title: "ออก",
      children: [
        {
          title: "วัน - เวลา",
          dataIndex: "out_datetime",
          key: "out_datetime",
          render: (value, original) => {
            return (
              <center>
                <div>{value ? dateToHumanString(value) : "-"}</div>
                <div>{value ? timeToString(value) : ""}</div>
              </center>
            );
          },
        },
        {
          title: "น้ำหนัก",
          dataIndex: "out_weight",
          key: "out_weight",
          render: (value, original) => (
            <>
              <Tooltip triger='hover' title={"ประวัติน้ำหนักออก"}>
                <a onClick={() => setTargetOutWeightLog({ id: original.id })}>
                  {formatComma(toFixed(value, 0))}
                </a>
              </Tooltip>
            </>            
          ),
        },
      ],
    },
    {
      title: 'น้ำหนักสุทธิ',
      dataIndex: 'net_weight',
      key: 'net_weight',
      render: (value) => formatComma(toFixed(value, 0))
    },
    {
      title: "Lot น้ำยางสด",
      dataIndex: "pond_input",
      key: "pond_input",
      render: (value, original) =>
        original.pond_input ? (
          <>
            <div>ล็อต : {_.get(original, "lot_no_input", "-")}</div>
            <div>บ่อ : {_.get(original, "pond_input", "-")}</div>
            <div>กระบะ : {_.get(original, "tray_input", "-")}</div>
          </>
        ) : (
          "-"
        ),
    },
    {
      title: "ผลแล็บ",
      dataIndex: "",
      key: "lab_results",
      render: (value, original) => {
        return _.get(original, "lab_results", "-").map((item) => {
          return (
            <div style={{ color: getLabResultColor(_.get(item, 'status', null)) }}>
              <Tooltip title={item.note}>{item.chemical} : {toFixed(item.amount, 3)}</Tooltip>
            </div>
          );
        });
      },
    },
    {
      title: 'น้ำหนักประมาณ',
      dataIndex: 'estimated_weight',
      key: 'estimated_weight',
      render: (value) => formatComma(toFixed(value, 0))
    },

  ];

  React.useEffect(() => {
    if(rangeDate.date_after){
     refreshData(rangeDate)
    } else {
      refreshData({date_after : "", date_before : ""})
    }
  },[rangeDate])

  React.useEffect(() => {
      pondDropdown.fetchOptions();
  },[])

  React.useEffect(() => {
    const interval = setInterval(() => {
      refreshData();
    }, 300000);

    return () => clearInterval(interval);
  }, []);


  return (
    <div style={{ marginTop : 16 }}>
      <ErrorMessages message={errorMessages} />
      วันที่ : 
      <DatePicker.RangePicker
        style={{ marginBottom : 10, marginLeft : 10, marginRight : 20 }}
        onCalendarChange={(dates, dateStrings) => setRangeDate({date_after : dateStrings[0], date_before : dateStrings[1]})}
        defaultValue={[dayjs(), dayjs()]}
      />
      <SummaryWeightLatex/>
      
      <TSTable
        ref={tableRef}
        columns={columns}
        size={"small"}
        url={URL_TRUCK.TRUCK_TRANSACTION}
        params={{...rangeDate }}
        rowClassName={(record) => {
          if (record.is_approved && !record.pond_input) {
            return "table-row-red";
          }
        }}
      />

      <ReceivingWeightLogModal
        open={targetInWeightLog ? true : false}
        target={targetInWeightLog}
        onClose={() => setTargetInWeightLog(null)}
        direction={"in"}
      />

      <ReceivingWeightLogModal
        open={targetOutWeightLog ? true : false}
        target={targetOutWeightLog}
        onClose={() => setTargetOutWeightLog(null)}
        direction={"out"}
      />
      
    </div>
  );
});

export default PondRecieveLatexView;
